<template>
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-3 col-md-2 sidebar">
            <ul class="nav nav-sidebar">

                <template v-if="this.user.role == 'Reader'  && this.user.phishing == true " >
                    <li>
                        <a href="/dashboard"><i><img class="dashboard_icons" src="../assets/images/icons/dashboard.png"/></i> Dashboard Phishing</a>
                    </li>
                    <li>
                        <a href="/campaigns"><i><img class="dashboard_icons" src="../assets/images/icons/megafone.png"/></i> Campaigns Phishing</a>
                    </li>
                </template>
				<template  v-if="this.user.role == 'Reader' &&  this.user.usb == true ">
                    <li>
                    <a href="/dashboardUsb"><i><img class="dashboard_icons" src="../assets/images/icons/dashboard.png"/></i> Dashboard Usb</a>
                    </li>
                    <li>
                     <a href="/campaignsUsb"><i><img class="dashboard_icons" src="../assets/images/icons/megafone.png"/></i> Campaigns Usb Ducky</a>
                    </li>
                </template>
               
                <template v-if="(this.user.role=='Admin' && this.user.phishing ==true )|| (this.user.role =='User' && this.user.phishing ==true ) || this.user.role=='Admin' && this.user.usb ==true">
                    <!-- la vecchia pagina era  daschboard + campagens -> sòpra nel primo template -->
                    <li>
                        <a href="/dashboard"><i><img class="dashboard_icons" src="../assets/images/icons/dashboard.png"/></i> Dashboard Phishing</a>
                    </li>
                    <li>
                         <a href="/campaigns"><i><img class="dashboard_icons" src="../assets/images/icons/megafone.png"/></i> Campaigns Phishing</a>
                    </li>
                    
                    <li>
                        <a href="/groups"><i><img class="dashboard_icons" src="../assets/images/icons/user_group.png"/></i> Users &amp; Groups</a>
                    </li>
                    <li>
                        <a href="/templates"><i><img class="dashboard_icons" src="../assets/images/icons/email_template_1.png"/></i> Email Templates</a>
                    </li>
                    <!--<li>
                        <a href="/landing_pages">Landing Pages</a>
                    </li>-->
                    <li>
                        <a href="/sending_profiles"><i><img class="dashboard_icons" src="../assets/images/icons/sending_profile.png"/></i> Sending Profiles</a>
                    </li>
                    <!-- aggiunta voce per campagne USB -->
                    <li>
                        <a href="/settings"><i><img class="dashboard_icons" src="../assets/images/icons/account_settings.png"/></i> Account Settings</a>
                    </li>
                    <li>
                        <a v-if="this.user.role == 'Admin' && this.user.phishing == true || this.user.role == 'Admin' && this.user.usb == true " href="/customers"><i><img class="dashboard_icons" src="../assets/images/icons/customers.png"/></i>  Customers<span class="nav-badge badge pull-right">Admin</span></a>
                    </li>
                    <li>
                        <a v-if="this.user.role == 'Admin'  && this.user.phishing == true || this.user.role == 'Admin' && this.user.usb == true " href="/users"><i><img class="dashboard_icons" src="../assets/images/icons/gear.png"/></i>  User Management<span class="nav-badge badge pull-right">Admin</span></a>
                    </li>
                </template>
            
                <template v-if="(this.user.role == 'Admin' && this.user.usb == true )">
                    <!-- aggiunta voce per campagne USB -->
                    <li>
                    <a href="/dashboardUsb"><i><img class="dashboard_icons" src="../assets/images/icons/dashboard.png"/></i> Dashboard Usb</a>
                    </li>
                    <li>
                     <a href="/campaignsUsb"><i><img class="dashboard_icons" src="../assets/images/icons/megafone.png"/></i> Campaigns Usb Ducky</a>
                    </li>
                </template>
                <template v-if="(this.user.role =='User' &&  this.user.usb == true) ">
                    <!-- aggiunta voce per campagne USB -->
                    <li>
                    <a href="/dashboardUsb"><i><img class="dashboard_icons" src="../assets/images/icons/dashboard.png"/></i> Dashboard Usb</a>
                    </li>
                    <li>
                     <a href="/campaignsUsb"><i><img class="dashboard_icons" src="../assets/images/icons/megafone.png"/></i> Campaigns Usb Ducky</a>
                    </li>
                </template>
               
            </ul>
        </div>
    </div>
</div>
</template>

<script>
    export default {
        name: 'HelLeftNavMenu',
        data: function() {
            return {
                utente : null,
            }
        },
        methods: {
            getUserFromSession() {
                this.utente = window.sessionStorage.getItem('user');
            }
        },
        beforeMount() {
            this.user = window.sessionStorage.getItem("user");
            this.user = JSON.parse(this.user);
            if (null != this.user) {
                this.username = this.user.username;
            }
            this.getUserFromSession()


        },
    }
    
    
</script>

<style></style>